import {
  VuexModule,
  Module,
  Mutation,
  getModule,
} from "vuex-module-decorators";
import store from "@/store";

@Module({ dynamic: true, store, name: "vulnTracker.Common", namespaced: true })
export class Common extends VuexModule {
  apiErrors: string[] = [];

  @Mutation
  ClearApiErrors() {
    this.apiErrors = [];
  }

  @Mutation
  AddApiError(payload: { target: string; message: string }) {
    const error =
      "エラー発生（" +
      payload.target +
      "）：" +
      (typeof payload.message === "string" ? payload.message : "Fatal Error");
    this.apiErrors.push(error);
  }
}

export const VulnTrackerCommonModule = getModule(Common);
